<template>
  <div
    class="seat-map-loader bg-background-neutral-secondary flex w-full flex-col items-center space-y-6 rounded-2xl p-6"
  >
    <img src="@/assets/images/main/plane.webp" alt="" width="48" height="48" />
    <div class="space-y-1 text-center">
      <h2 class="text-text-neutral-primary text-lg font-semibold">
        {{ $t('ancillaries.seatMap.loader.title') }}
      </h2>
      <p class="text-text-neutral-secondary text-sm font-medium">
        {{ $t('ancillaries.seatMap.loader.message') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
  .seat-map-loader {
    box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.05);
  }
</style>
